import { IProject } from "../models";

export const aboutMe = {
  youtubeLink: "https://www.youtube.com/channel/UCV4AXpDSxschk8I0sCl8JXw",
  blogLink: "https://www.explainedsimply.io",
  resumeLink: "https://particle-frame.herokuapp.com/resume",
  githubLink: "https://github.com/pkellz",
  emailLink: "hello@pscott.io",
  musicLink: "https://youtu.be/8FqGJ8chrrc",
} as const;

export const projects: IProject[] = [
  {
    name: "velina.io",
    link: "https://velina.io/",
    img: "velina.webp",
    description: [
      `Maximize your profits with risk-free bets across prediction markets.
Velina finds the best arbitrage opportunities in near real-time so you never miss an edge.`,
    ],
    architecture: [],
    tech: [
      "Next.js",
      "Vercel",
      "MongoDB",
      "Vector Database",
      "TypeScript",
      "OpenAI",
    ],
    show: true,
  },
  {
    name: "Advanced Postings",
    link: "https://advancedpostings.com/",
    img: "advancedpostings.webp",
    description: [
      "Helping governments across several South Carolina counties collect unpaid property taxes by printing & posting delinquent tax notices on their behalf. I co-founded this business with one partner.",
    ],
    architecture: [],
    tech: ["React.js", "Node.js", "MongoDB", "TypeScript", "Microsoft Azure"],
    show: true,
  },
  {
    name: "Build React.js From Scratch",
    link: "https://buildreactjs.io/",
    img: "buildreact.webp",
    description: [
      `I teach developers how to build their own dev tools from scratch by deconstructing existing tools (like React 16) to understand the patterns and principles behind them.`,
    ],
    architecture: [],
    tech: ["HTML5", "CSS3", "Digital Ocean", "nginx", "Github Actions"],
    show: true,
  },

  {
    name: "DevSage YouTube",
    link: "https://www.youtube.com/channel/UCV4AXpDSxschk8I0sCl8JXw",
    img: "devsage-yt.webp",
    description: [
      "DevSage is my YouTube channel where I teach web development / programming to my lovely audience of nearly 20,000 people.",
    ],
    architecture: [],
    tech: [],
    show: false,
  },
  {
    name: "devsage.io",
    link: "https://devsage.io",
    img: "devsage.webp",
    description: [
      "The brand website for my YouTube channel - DevSage. I market my online courses here. (Not yet complete)",
    ],
    architecture: [`This was built with Wordpress.`],
    tech: ["Wordpress"],
    show: false,
  },
  {
    name: "explainedsimply.io",
    link: "https://explainedsimply.io/",
    img: "explainedsimply.webp",
    description: [
      `explainedsimply.io is my blog with a mission to make web development simpler through easy-to-understand explanations.`,
    ],
    architecture: [],
    tech: ["Jekyll", "GitHub Actions", "Digital Ocean", "nginx"],
    show: true,
  },
];
